'use client'

import type { PropsWithChildren, ReactNode } from 'react'
import { Header } from '~/components/refineUi/layout/header'
import { Sidebar } from '~/components/refineUi/layout/sidebar'
import { SidebarInset, SidebarProvider } from '~/components/ui/sidebar'
import { cn } from '~/lib/utils'

export function Layout({
  children,
  headerStart,
}: PropsWithChildren<{
  /** rendered in the header before the theme toggle and user menu */
  headerStart?: ReactNode
}>) {
  return (
    <SidebarProvider>
      <Sidebar />
      <SidebarInset>
        <Header start={headerStart} />
        <main
          className={cn(
            '@container/main',
            'container',
            'mx-auto',
            'relative',
            'w-full',
            'flex',
            'flex-col',
            'flex-1',
            'px-2',
            'pt-4',
            'md:p-4',
            'lg:px-6',
            'lg:pt-6',
          )}
        >
          {children}
        </main>
      </SidebarInset>
    </SidebarProvider>
  )
}

Layout.displayName = 'Layout'
